import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Skills = () => {
  useEffect(() => {
    const progressBars = document.querySelectorAll('.rc-progress-line-path');

    progressBars.forEach(bar => {
      const length = bar.getTotalLength();
      bar.style.transition = 'none';
      bar.style.strokeDasharray = length + 'px ' + length + 'px';
      bar.style.strokeDashoffset = length + 'px';

      setTimeout(() => {
        bar.style.transition = 'stroke-dashoffset 1s ease-in-out';
        bar.style.strokeDashoffset = '0px';
      }, 200);
    });
  }, []);

  return (
    <div className="container mx-auto shadow-lg rounded-lg p-8">
      <section className="py-12" style={{ backgroundColor: '#393E46' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-6">
          <div className="text">
            <motion.h2 
              className="my-4 font-bold text-3xl sm:text-4xl animate-slide"
              whileHover={{ scale: 1.05 }} // Hover animation
              initial={{ opacity: 0, x: -50 }} // Initial state
              animate={{ opacity: 1, x: 0 }} // Animation state
              transition={{ duration: 0.5, delay: 0.2 }} // Animation duration and delay
              style={{ color: 'white' }}
            >
              MY <span className="text-blue-500">Skills</span>
            </motion.h2>
          </div>

          <div className="mb-7">
            <div className="flex justify-between py-1">
              <span className="text-base text-white font-semibold">Web Design</span>
              <span className="text-base font-semibold pr-5 text-white">80%</span>
            </div>
            <svg className="rc-progress-line" viewBox="0 0 100 1" preserveAspectRatio="none">
              <path className="rc-progress-line-trail" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#D9D9D9" strokeWidth="1" fillOpacity="0"></path>
              <path className="rc-progress-line-path" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#007BFF" strokeWidth="1" fillOpacity="0" style={{ strokeDasharray: '79.2px, 100px', strokeDashoffset: '0px', transition: 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s, stroke 0.3s linear 0s, 0.06s'}}></path>
            </svg>
          </div>

          <div className="mb-7">
            <div className="flex justify-between py-1">
              <span className="text-base text-white font-semibold">Web App</span>
              <span className="text-base font-semibold pr-5 text-white">95%</span>
            </div>
            <svg className="rc-progress-line" viewBox="0 0 100 1" preserveAspectRatio="none">
              <path className="rc-progress-line-trail" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#D9D9D9" strokeWidth="1" fillOpacity="0"></path>
              <path className="rc-progress-line-path" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#007BFF" strokeWidth="1" fillOpacity="0" style={{ strokeDasharray: '94.05px, 100px', strokeDashoffset: '0px', transition: 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s, stroke 0.3s linear 0s, 0.06s'}}></path>
            </svg>
          </div>

          <div className="mb-7">
            <div className="flex justify-between py-1">
              <span className="text-base text-white font-semibold">Responsive Design</span>
              <span className="text-base font-semibold pr-5 text-white">85%</span>
            </div>
            <svg className="rc-progress-line" viewBox="0 0 100 1" preserveAspectRatio="none">
              <path className="rc-progress-line-trail" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#D9D9D9" strokeWidth="1" fillOpacity="0"></path>
              <path className="rc-progress-line-path" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#007BFF" strokeWidth="1" fillOpacity="0" style={{ strokeDasharray: '84.8px, 100px', strokeDashoffset: '0px', transition: 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s, stroke 0.3s linear 0s, 0.06s'}}></path>
            </svg>
          </div>

          <div className="mb-7">
            <div className="flex justify-between py-1">
              <span className="text-base text-white font-semibold">API Making</span>
              <span className="text-base font-semibold pr-5 text-white">75%</span>
            </div>
            <svg className="rc-progress-line" viewBox="0 0 100 1" preserveAspectRatio="none">
              <path className="rc-progress-line-trail" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#D9D9D9" strokeWidth="1" fillOpacity="0"></path>
              <path className="rc-progress-line-path" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#007BFF" strokeWidth="1" fillOpacity="0" style={{ strokeDasharray: '84.8px, 100px', strokeDashoffset: '0px', transition: 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s, stroke 0.3s linear 0s, 0.06s'}}></path>
            </svg>
          </div>

          <div className="mb-7">
            <div className="flex justify-between py-1">
              <span className="text-base text-white font-semibold">Database</span>
              <span className="text-base font-semibold pr-5 text-white">90%</span>
            </div>
            <svg className="rc-progress-line" viewBox="0 0 100 1" preserveAspectRatio="none">
              <path className="rc-progress-line-trail" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#D9D9D9" strokeWidth="1" fillOpacity="0"></path>
              <path className="rc-progress-line-path" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#007BFF" strokeWidth="1" fillOpacity="0" style={{ strokeDasharray: '84.8px, 100px', strokeDashoffset: '0px', transition: 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s, stroke 0.3s linear 0s, 0.06s'}}></path>
            </svg>
          </div>

          <div className="mb-7">
            <div className="flex justify-between py-1">
              <span className="text-base text-white font-semibold">Frontend Development</span>
              <span className="text-base font-semibold pr-5 text-white">90%</span>
            </div>
            <svg className="rc-progress-line" viewBox="0 0 100 1" preserveAspectRatio="none">
              <path className="rc-progress-line-trail" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#D9D9D9" strokeWidth="1" fillOpacity="0"></path>
              <path className="rc-progress-line-path" d="M 0.5,0.5 L 99.5,0.5" strokeLinecap="round" stroke="#007BFF" strokeWidth="1" fillOpacity="0" style={{ strokeDasharray: '84.8px, 100px', strokeDashoffset: '0px', transition: 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s, stroke 0.3s linear 0s, 0.06s'}}></path>
            </svg>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Skills;
